var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { IconWrapper, MaskIcon } from '../styled';
/**
 * @deprecated should not be used. We have deprecated all old SVG Icons
 */
export function Icon(props) {
    const { glyph: Glyph, size = 4, alignment = 'top', primaryColor = 'currentColor', label, className, title } = props, restProps = __rest(props, ["glyph", "size", "alignment", "primaryColor", "label", "className", "title"]);
    const src = typeof Glyph === 'string' && Glyph;
    return (<IconWrapper {...restProps} className={className} $size={size} $alignment={alignment} $primaryColor={primaryColor} aria-label={label} title={title}>
      {src ? <MaskIcon $size={size} $alignment={alignment} $src={src}/> : <Glyph />}
    </IconWrapper>);
}
